<template>
	<el-menu default-active="0" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose"
		active-text-color="#fff" background-color="#5628e8" text-color="#fff">
		<div class="logo-box">
			<img class="logo-box-image" src="../assets/logo.jpg" />
			<span>福斯华服务平台</span>
		</div>
		<el-menu-item index="0" class="submenu" @click="goToBanners" v-if="role == 0">
			<template slot="title">
				<i class="iconfont icon-lunbotuguanli menu_icon"></i>
				<span class="menu_text">轮播图管理</span>
			</template>
		</el-menu-item>
		<el-menu-item index="1" class="submenu" @click="goToNotice" v-if="role == 0">
			<template slot="title">
				<i class="iconfont icon-chongqingfankui menu_icon"></i>
				<span class="menu_text">通知管理</span>
			</template>
		</el-menu-item>
		<el-menu-item index="2" class="submenu" @click="goToNews" v-if="role == 0">
			<template slot="title">
				<i class="iconfont icon-xinwendongtai menu_icon"></i>
				<span class="menu_text">资讯管理</span>
			</template>
		</el-menu-item>
		<el-menu-item index="3" class="submenu" @click="goToUsers" v-if="role == 0">
			<template slot="title">
				<i class="iconfont icon-chaqirenyuanguanli menu_icon"></i>
				<span class="menu_text">人员管理</span>
			</template>
		</el-menu-item>
		<el-submenu index="4" class="submenu">
			<template slot="title">
				<i class="iconfont icon-xinxiweihu menu_icon"></i>
				<span class="menu_text">上报管理</span>
			</template>
			<el-menu-item index="4-1" @click="goToRepair" class="second_menu">
				<template slot="title">
					<span class="menu_text">咨询/报修管理</span>
				</template>
			</el-menu-item>
			<el-menu-item index="4-2" @click="goToService" class="second_menu">
				<template slot="title">
					<span class="menu_text">服务预约管理</span>
				</template>
			</el-menu-item>
			<el-menu-item index="4-3" @click="goToComplaints" class="second_menu">
				<template slot="title">
					<span class="menu_text">服务投诉管理</span>
				</template>
			</el-menu-item>
		</el-submenu>
		<div class="bottom_btns">
			<el-menu-item index="99" class="submenu" @click="logout">
				<template slot="title">
					<i class="iconfont icon-tuichu menu_icon"></i>
					<span class="menu_text">退出</span>
				</template>
			</el-menu-item>
		</div>
	</el-menu>
</template>

<script>
	export default {
		name: 'AppSidebar',
		data() {
			return {
				isCollapse: true,
				role: 0
			}
		},
		mounted() {
			console.log("login", JSON.parse(localStorage.getItem('token')))
			this.role = JSON.parse(localStorage.getItem('token')).role
			console.log("本次登录权限", this.role)
		},
		methods: {
			handleOpen(key, keyPath) {
				console.log(key, keyPath);
			},
			handleClose(key, keyPath) {
				console.log(key, keyPath);
			},
			goToBanners() {
				if (this.$route.path !== '/') {
					this.$router.push({
						name: 'bannerList'
					});
				}
			},
			goToNotice() {
				if (this.$route.path !== '/notice-page') {
					this.$router.push({
						name: 'noticePage'
					});
				}
			},
			goToNews() {
				if (this.$route.path !== '/news-page') {
					this.$router.push({
						name: 'newsPage'
					});
				}
			},
			goToUsers() {
				if (this.$route.path !== '/users-page') {
					this.$router.push({
						name: 'usersPage'
					});
				}
			},
			goToRepair() {
				if (this.$route.path !== '/repair-page') {
					this.$router.push({
						name: 'repairPage'
					});
				}
			},
			goToService() {
				if (this.$route.path !== '/service-page') {
					this.$router.push({
						name: 'servicePage'
					});
				}
			},
			goToComplaints() {
				if (this.$route.path !== '/complaints-page') {
					this.$router.push({
						name: 'complaintsPage'
					});
				}
			},
			logout() {
				this.$store.commit('setLoggedIn', false);
				this.$router.push('/login');
			}
		}
	};
</script>

<style scoped>
	.sidebar {
		background-color: #545c64;
		height: calc(100vh - 60px);
		position: relative;
	}

	.el-menu-vertical-demo {
		height: 100vh;
		overflow-x: hidden;
	}

	.logo-box-image {
		width: 50px;
		height: 50px;
		background-color: #fff;
		padding: 10px;
		border-radius: 70px;


	}

	.logo-box {
		width: 100%;
		height: 180px;
		background-color: #5628e8;
		display: flex;
		justify-content: center;
		flex-direction: column;
		align-items: center;
		color: #fff;
	}

	.logo-box span {
		margin-top: 20px;
	}

	.menu_icon {
		font-size: 30px;
		color: #fff;
	}

	.menu_text {
		margin-left: 25px;
	}

	.el-menu-item__title:hover {
		background-color: #f0f9ff;
		color: #409EFF;
	}

	/* 子菜单项悬停 */
	.el-menu-item:hover {
		background-color: #e6f7ff;
	}

	/deep/ .is-active {
		background-color: #5f56f7 !important;
	}

	.bottom_btns {
		position: absolute;
		bottom: 20px;
	}

	.bottom_btns .menu_icon {
		font-size: 25px;
	}

	.second_menu {
		background-color: #5a2af7 !important;
	}

	.second_menu:hover {
		background-color: #5f56f7 !important;
	}

	/deep/ .second_menu.is-active {
		background-color: #5f56f7 !important;
	}
</style>